import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-atualiza-cep-modal',
  templateUrl: './atualiza-cep-modal.component.html',
  styleUrls: ['./atualiza-cep-modal.component.scss']
})
export class AtualizaCepModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  constructor(public dialogRef: MatDialogRef<AtualizaCepModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document) { }

  ngOnInit(): void {

    let script = document.createElement('script');
    script.type = 'text/javascript';   
    script.text = `
  {   
    /* Enter other needed data here */
    //atribui elemento com ID "viacep-embed" no documento.
                var elemento_pai = document.getElementById("viacep-embed");
                //cria um novo elemento "iframe".
                var iframe = document.createElement('iframe');
                //insere o novo elemento "iframe" como filho do elemento "viacep-embed".
                elemento_pai.appendChild(iframe);
                //define atributos do "iframe".
                iframe.setAttribute('src', 'https://viacep.com.br/embed/');
                iframe.setAttribute('id', 'viacep-iframe');
                iframe.setAttribute('scrolling', 'no');
                // iframe.style.width = '210px';
                iframe.style.height = '240px';       
                iframe.style.border = '1px dotted #888';
                iframe.style.background = '#fcfcfc';
  }
`;
       
    document.body.appendChild(script);

   
  }

  fechar() {
    this.dialogRef.close();
  }

}
